 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import SS_DRM_NOTICE from '@/components/SS_DRM_notice'
 import DEDICATION from '@/components/dedication'
 import HISTORIANSNOTE from '@/components/historiansnote'
 import EPIGRAPH from '@/components/epigraph'
 import CH01 from '@/components/ch01'
 import CH02 from '@/components/ch02'
 import CH03 from '@/components/ch03'
 import CH04 from '@/components/ch04'
 import CH05 from '@/components/ch05'
 import CH06 from '@/components/ch06'
 import EPILOGUE from '@/components/epilogue'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import SS_RECOMMENDPAGE from '@/components/SS_recommendpage'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
 import COPYRIGHT from '@/components/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/SS_US_adult_signup_front",
 			"name" : "SS_US_adult_signup_front",
 			"component" : SS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/SS_DRM_notice",
 			"name" : "SS_DRM_notice",
 			"component" : SS_DRM_NOTICE
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/historiansnote",
 			"name" : "historiansnote",
 			"component" : HISTORIANSNOTE
 		},
 		{
 			"path" : "/epigraph",
 			"name" : "epigraph",
 			"component" : EPIGRAPH
 		},
 		{
 			"path" : "/ch01",
 			"name" : "ch01",
 			"component" : CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js